import ProductStore from "@src/model/product-repo";
import { CategorySingle } from "@src/model/product-single";
import React from "react";
import { Menu } from "heroicons-react";
import { observer, useLocalObservable } from "mobx-react";

const ProductCategory = observer(({ currentOrder }: any) => {
  let listCategories = ProductStore.listCategories;

  const meta = useLocalObservable(() => ({
    showCategoryModal: false
  }));

  if (currentOrder.productMember.list.length > 0) {
    listCategories = currentOrder.productMember.categories;
  }

  return (
    <div className="px-4 mb-2 flex flex-col items-start">
      <div className="font-bold mr-4 my-2">Category:</div>
      <div className="flex flex-1 w-full">
        <div className="flex flex-row flex-wrap overflow-scroll">
        <button
          className={`flex rounded-md py-2 px-6 mr-2 mb-1 bg-gray-200 hover:bg-blue-200 text-md ripple hover:shadow-md`}
          onClick={()=>{
            meta.showCategoryModal=!meta.showCategoryModal
          }}
        >
          <Menu/>
        </button>
          {Array.isArray(listCategories) && listCategories.length > 0 ? (
            listCategories.map((item) => (
              <Item
                key={String(item.id)}
                item={item}
                currentOrder={currentOrder}
              />
            ))
          ) : (
            <h1>-</h1>
          )}
        </div>
      </div>
    </div>
  );
});

const Item: React.FC<Record<string, any>> = observer((props) => {
  const item: CategorySingle = props.item;
  const currentOrder = props.currentOrder;
  let activeCategory = ProductStore.activeCategory;
  if (currentOrder.productMember.list.length > 0) {
    activeCategory = currentOrder.productMember.activeCategory;
  }
  const action = () => {
    if (currentOrder.productMember.list.length > 0) {
      currentOrder.productMember.setCategory(item.id);
    } else {
      ProductStore.setCategory(item.id);
    }
  };
  let activeStyle = "";
  if (item.id === activeCategory) {
    activeStyle = "hover:bg-blue-500 bg-blue-500 text-white";
  }

  return (
    <button
      onClick={action}
      className={`flex rounded-md py-2 px-6 mr-2 mb-1 bg-gray-200 hover:bg-blue-200 text-md ripple hover:shadow-md ${activeStyle}`}
    >
      {item.name}
    </button>
  );
});

export default ProductCategory;
